import user from './user/reducer';
import sims from './sims/reducer';
import zones from './zones/reducer';
import fleets from './fleets/reducer';
import agents from './agents/reducer';
import vendors from './vendors/reducer';
import returns from './returns/reducer';
import refuels from './refuels/reducer';
import affords from './affords/reducer';
import outlays from './outlays/reducer';
import expenses from './expenses/reducer';
import revenues from './revenues/reducer';
import agencies from './agencies/reducer';
import settings from './settings/reducer';
import managers from './managers/reducer';
import supplies from './supplies/reducer';
import payments from './payments/reducer';
import movements from './movements/reducer';
import operators from './operators/reducer';
import transfers from './transfers/reducer';
import companies from './companies/reducer';
import simsTypes from './simsTypes/reducer';
import overseers from './overseers/reducer';
import handovers from './handovers/reducer';
import recoveries from './recoveries/reducer';
import clearances from './clearances/reducer';
import collectors from './collectors/reducer';
import accountants from './accountants/reducer';
import supervisors from './supervisors/reducer';
import transactions from './transactions/reducer';
import userRequests from './requests/user/reducer';
import simsRequests from './requests/sims/reducer';
import notifications from './notifications/reducer';
import zonesRequests from './requests/zones/reducer';
import administrators from './administrators/reducer';
import agentsRequests from './requests/agents/reducer';
import fleetsRequests from './requests/fleets/reducer';
import refuelsRequests from './requests/refuels/reducer';
import returnsRequests from './requests/returns/reducer';
import affordsRequests from './requests/affords/reducer';
import vendorsRequests from './requests/vendors/reducer';
import outlaysRequests from './requests/outlays/reducer';
import paymentsRequests from './requests/payments/reducer';
import settingsRequests from './requests/settings/reducer';
import managersRequests from './requests/managers/reducer';
import suppliesRequests from './requests/supplies/reducer';
import revenuesRequests from './requests/revenues/reducer';
import expensesRequests from './requests/expenses/reducer';
import agenciesRequests from './requests/agencies/reducer';
import overseersRequests from './requests/overseers/reducer';
import operatorsRequests from './requests/operators/reducer';
import transfersRequests from './requests/transfers/reducer';
import simsTypesRequests from './requests/simsTypes/reducer';
import handoversRequests from './requests/handovers/reducer';
import companiesRequests from './requests/companies/reducer';
import movementsRequests from './requests/movements/reducer';
import collectorsRequests from './requests/collectors/reducer';
import clearancesRequests from './requests/clearances/reducer';
import recoveriesRequests from './requests/recoveries/reducer';
import accountantsRequests from './requests/accountants/reducer';
import supervisorsRequests from './requests/supervisors/reducer';
import transactionsRequests from './requests/transactions/reducer';
import notificationsRequests from './requests/notifications/reducer';
import administratorsRequests from './requests/administrators/reducer';

// Combine all reducers
export default {
    user,
    sims,
    zones,
    agents,
    fleets,
    returns,
    refuels,
    affords,
    vendors,
    outlays,
    revenues,
    agencies,
    settings,
    managers,
    supplies,
    payments,
    expenses,
    operators,
    transfers,
    movements,
    simsTypes,
    companies,
    handovers,
    overseers,
    recoveries,
    clearances,
    collectors,
    supervisors,
    accountants,
    simsRequests,
    userRequests,
    transactions,
    zonesRequests,
    notifications,
    fleetsRequests,
    agentsRequests,
    administrators,
    outlaysRequests,
    returnsRequests,
    refuelsRequests,
    vendorsRequests,
    affordsRequests,
    agenciesRequests,
    revenuesRequests,
    expensesRequests,
    suppliesRequests,
    managersRequests,
    settingsRequests,
    paymentsRequests,
    overseersRequests,
    movementsRequests,
    handoversRequests,
    simsTypesRequests,
    transfersRequests,
    operatorsRequests,
    companiesRequests,
    recoveriesRequests,
    clearancesRequests,
    collectorsRequests,
    supervisorsRequests,
    accountantsRequests,
    transactionsRequests,
    notificationsRequests,
    administratorsRequests,
};
